export const arrayTypeFilesForm = [
  {
    value: 1,
    label: 'Documento .pdf',
    formatAccept: 'application/pdf',
    validateFormat: 'pdf',
    validateFormatMsg: 'Solo se admite PDF',
    type: 'application/pdf',
  },
  {
    value: 2,
    label: 'Documento .csv',
    formatAccept: '.csv',
    validateFormat: 'csv',
    validateFormatMsg: 'Solo se admite CSV',
    type: 'text/csv',
  },
  {
    value: 3,
    label: 'Imagen .jpg',
    formatAccept: '.jpg',
    validateFormat: 'jpg',
    validateFormatMsg: 'Solo se admite imagenes .jpg',
    type: 'image/jpeg',
  },
  {
    value: 4,
    label: 'Imagen .png',
    formatAccept: '.png',
    validateFormat: 'png',
    validateFormatMsg: 'Solo se admite imagenes .png',
    type: 'image/png',
  },
  {
    value: 5,
    label: 'Imagenes (jpg, jpeg, png)',
    formatAccept: '.jpg,.jpeg,.png',
    validateFormat: 'imageavatar',
    validateFormatMsg: 'Solo se admite JPG, JPGE y PNG',
    type: 'image/*',
  },
  {
    value: 6,
    label: 'Todos los formatos',
    formatAccept: '.pdf,.csv,.jpg,.jpeg,.png',
    validateFormat: 'all',
    validateFormatMsg: 'Solo se admite pdf, csv, jpg, jpge y png',
    type: '*',
  },
]
